import { createContext, useContext, useState, type ReactNode } from "react";
import type { Station } from "../lib/m3u";

type PlayerContextValue = {
  station: Station | null;
  play: (station: Station) => void;
  stop: () => void;
};

const PlayerContext = createContext<PlayerContextValue | null>(null);

export function PlayerProvider({ children }: { children: ReactNode }) {
  const [station, setStation] = useState<Station | null>(null);

  return (
    <PlayerContext.Provider value={{ station, play: setStation, stop: () => setStation(null) }}>
      {children}
    </PlayerContext.Provider>
  );
}

export function usePlayer(): PlayerContextValue {
  const context = useContext(PlayerContext);
  if (!context) throw new Error("usePlayer must be used inside PlayerProvider");
  return context;
}
